import type { Polygon } from "geojson";
import { api } from "./api";

/** 8-point compass direction from the nearest existing field to the candidate. */
export type TCompass8 = "N" | "NE" | "E" | "SE" | "S" | "SW" | "W" | "NW";

/** One harvested area without a boundary, as proposed by the backend. */
export type TFieldFromTracksCandidate = {
  /** Stable for identical geometry; a list key only. */
  id: string;
  geometry: Polygon;
  areaHa: number;
  /** Ground a header actually covered (<= areaHa). */
  coveredHa: number;
  firstAt: string;
  lastAt: string;
  devices: { esn: string; name: string | null }[];
  /** Closest existing field within 150 m — used for the default name. */
  nearField: { name: string; direction: TCompass8 } | null;
  /** Bigger than a field may be; offered unticked and cannot be created. */
  exceedsMaxArea: boolean;
};

export type TFieldsFromTracksResult =
  | { status: "running"; startedAt: string }
  | { status: "failed"; error: string }
  | {
      status: "ready";
      computedAt: string;
      from: string;
      to: string;
      truncated: boolean;
      candidates: TFieldFromTracksCandidate[];
    };

/**
 * Candidate boundaries for this season's harvested ground that no field covers.
 * The first call starts a season scan on the server and answers `running`;
 * poll until `ready` or `failed`. The result is stored server-side, so a later
 * call (after a reload, the next day) returns it without scanning again;
 * `rescan` asks for a fresh scan. Silent: the dialog reports errors inline.
 */
export const getFieldsFromTracks = (seasonId: string, rescan = false) =>
  api.get<TFieldsFromTracksResult>(
    "/api/v1/fields/from-tracks",
    { seasonId, ...(rescan ? { rescan: "1" } : {}) },
    { silent: true }
  );
